// extracted by mini-css-extract-plugin
export default {"projectForm":"Project_projectForm__ZEHWi","projectNames":"Project_projectNames__y-tSF","featured":"Project_featured__N0tJY"};